import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

import {
  // Hero,
  Gallery,
  Movie,
  // Content,
  Banner,
  Section,
  Heading,
  TimeItem,
} from "../../page_components/krakow-sky-run"

const KrakowSkyRun = () => {
  const lang = "pl"

  return (
    <Layout lang={lang} translation="/unity-sky-run/">
      <SEO title="Unity Sky Run" />

      {/* <Hero description="Wyprzedź konkurencję i bądź liderem w biegu na szczyt UNITY CENTRE." />
      <Content
        master={{
          title: "Zmierz się z mistrzem!",
          description:
            "W tym roku biegnie z nami Grzegorz Sudoł – polski lekkoatleta, specjalizujący się w chodzie sportowym. Trzykrotny olimpijczyk, brązowy medalista mistrzostw świata oraz srebrny medalista mistrzostw Europy.",
        }}
        roundTitle={
          <>
            BIEG
            <br />
            odbędzie się w dwóch turach
          </>
        }
        roundDescription={{
          first:
            "Dla zarejestrowanych uczestników ABSL Summit oraz pracowników firm, których przedstawiciele zarejestrowali się na ABSL Summit.",
          second:
            "Dla pracowników organizacji sektora usług biznesowych z siedzibą w Krakowie. Zapraszamy wszystkie firmy!",
        }}
        lang={lang}
      >
        <h2>
          Kraków Sky Run –<br />
          Powered by UNITY Centre
        </h2>
        <p>
          Wyprzedź konkurencję i bierz udział w wyjątkowym biegu na UNITY Tower
          przy ulicy Aleksandra Lubomirskiego 20 w Krakowie. Biegnij na 25
          piętro, daj z siebie wszystko, aby uzyskać najlepszy czas i zdobyć
          nagrody!
        </p>
      </Content>
      <Banner>
        <h4>
          Mamy już za sobą dwie edycje
          <br />
          Kraków Sky Run - Powered by Unity Centre, <br />
          które były niesamowitymi wydarzeniami.
        </h4>
        <h3>
          W tym roku biegniemy w dniu 25.06.2025 roku. Po więcej informacji
          skontaktuj się z twoim koordynatorem w ABSL lub Office Managerem.
        </h3>
      </Banner> */}

      <Section
        heading={
          <Heading
            title="Unity Sky Run 2026"
            html="<p>Wbiegliście na 26. piętro budynku #UNITYCentre z niesamowitą energią! Wasz ogromny głód sportowych emocji całkowicie nas zaskoczył – na starcie stanęło 150 zawodników!</p><p>Dziękujemy za każdy krok, pot i uśmiech na mecie. To Wasze zaangażowanie stworzyło tę niezapomnianą atmosferę. Jesteście absolutnie niesamowici!</p><p>Ogromne gratulacje dla wszystkich, którzy podjęli to wyzwanie i zdobyli szczyt!  Do zobaczenia za rok!</p>"
          />
        }
        isGray
      />
      <Gallery />
      <Section
        heading={
          <Heading
            title="Unity Sky Run 2025"
            html="<p>Unity Sky Run 2025, czyli bieg na 24 piętro budynku #UNITYCentre za nami!</p><p>Liczba chętnych zdecydowanie nas zaskoczyła, w biegu wzięło udział ponad 100 uczestników!</p><p>Dziękujemy wszystkim uczestnikom za udział w naszym biegu! Wasza energia i zaangażowanie sprawiły, że to wydarzenie było niezapomniane. Jesteście niesamowici!</p><p>Ogromne podziękowania i gratulacje dla wszystkich uczestników! Dzięki Wam, Kraków Sky Run może być początkiem nowej sportowej tradycji w #UNITYCENTRE.</p>"
          />
        }
        pbSmall
      />
      <Gallery year="2025" />
      <Movie />
      <Section
        heading={
          <Heading
            title="Kraków Sky Run 2024"
            description="Do drugiej edycji zapisało się 120 osób. Wydarzenie spotkało się z dużym zainteresowaniem. Każdy został nagrodzony upominkiem oraz pamiątkowym medalem. Zapraszamy do obejrzenia relacji z wydarzenia."
          />
        }
        content={[
          {
            headings: ["Rekordy czasowe", "Kobiety"],
            elements: [
              <TimeItem
                time="3:17"
                title="I miejsce"
                labels={["MONIKA PRZYBYŁO"]}
              />,
              <TimeItem
                time="3:18"
                title="II miejsce"
                labels={["MARGARYTA IEVTUKH"]}
              />,
              <TimeItem
                time="3:29"
                title="III miejsce"
                labels={["JULIANNA SIWEK", "ANETA SAMKOFF"]}
              />,
            ],
          },
          {
            headings: ["Rekordy czasowe", "Mężczyźni"],
            elements: [
              <TimeItem
                time="2:29"
                title="I miejsce"
                labels={["PAWEŁ BARCIK"]}
              />,
              <TimeItem
                time="2:31"
                title="II miejsce"
                labels={["ANDRZEJ OCHOWICZ"]}
              />,
              <TimeItem
                time="2:52"
                title="III miejsce"
                labels={["TYMOTEUSZ KRUK"]}
              />,
            ],
          },
        ]}
        pbSmall
      />
      <Gallery year="2024" />
      <Section
        heading={
          <Heading
            title="Kraków Sky Run 2023"
            description="Ponad 90 osób wzięło udział w wydarzeniu, którego celem było pokonanie trasy biegu na 25. piętro wieżowca. Uczestników przywitały prezenty i nagrody, a także strefa relaksu zniesamowitym widokiem na panoramę miasta."
          />
        }
        content={[
          {
            headings: null,
            elements: [
              <img
                src={require("../../assets/images/krakow-sky-run/time-icon.svg")}
                alt=""
              />,
            ],
            isHiddenMobile: true,
          },
          {
            headings: ["Rekordy czasowe"],
            elements: [
              <TimeItem time="3:14" title="kobiety" />,
              <TimeItem time="2:26" title="mężczyźni" />,
            ],
          },
        ]}
        isContentBottomAligned
        isGray
      />
      <Banner
        image={require("../../assets/images/krakow-sky-run/medals-image.jpg")}
      />
      <Banner
        image={require("../../assets/images/krakow-sky-run/group-image.jpg")}
      >
        {/* <h4>
          Serdecznie zapraszamy
          <br />
          na trzecią edycję Kraków Sky Run 2025 - Powered by Unity Centre!
        </h4>
        <p>
          Dołącz do nas na to niesamowite wydarzenie i przeżyj niezapomniane
          chwile.
          <br />
          Więcej informacji już wkrótce.
        </p>
        <h3>Do zobaczenia na starcie!</h3> */}
      </Banner>
    </Layout>
  )
}

export default KrakowSkyRun
